import axiosInstance from '@/axiosInstance'
import { getApiUrl } from '@/helper'
import { URL } from '../../constatns'

export const loadData = async () => {
  return axiosInstance.get(`${getApiUrl()}${URL}`)
}

export const loadDataByUserId = async (id, payload) => {
  // return axiosInstance.get(`${getApiUrl()}${URL}/getByUserId/${id}`)
  return axiosInstance.post(`${getApiUrl()}${URL}/getByDateAndUserId/${id}`, {
    data: payload
  })
}

export const open = async (amount) => {
  return axiosInstance.get(`${getApiUrl()}${URL}/open?amount=${amount}`)
}

export const close = async (amount) => {
  return axiosInstance.get(`${getApiUrl()}${URL}/close?amount=${amount}`)
}

export const change = async (id, payload) => {
  return axiosInstance.post(`${getApiUrl()}${URL}/change/${id}`, {
    data: payload
  })
}

export const remove = async (id) => {
  return axiosInstance.delete(`${getApiUrl()}${URL}/${id}`)
}
